var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreArrowHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 7376,
    transform: "translate(-167 -282)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1041,
    transform: "translate(-167 -282)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.16 -108.556C1176.88 26.6262 986.629 207.619 816.158 282.352C619.701 368.459 496.969 292.631 363.004 392.718C240.737 484.017 280.513 593.877 188.169 655.533C103.301 712.192 -70.8287 713.256 -453.176 502.877",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-448.103 483.655C-70.7298 690.745 104.598 692.125 192.049 637.729C256.83 597.34 260.218 533.786 296.063 469.18C313.67 436.303 339.963 406.179 372.581 381.511C479.392 300.639 577.569 329.187 716.499 297.901C751.945 290.003 786.942 278.707 820.768 264.247C992.834 191.209 1185.32 21.9237 1157.14 -110.274",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-442.98 464.463C-70.5923 668.242 105.842 672.082 195.672 620.015C261.702 581.738 267.774 519.934 304.652 457.328C323.24 424.908 349.655 395.186 381.883 370.428C486.773 289.875 582.224 312.436 721.054 279.742C756.359 271.487 791.234 260.256 825.121 246.231C998.625 174.466 1193.51 17.3326 1170.87 -111.881",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-437.867 445.326C-70.548 645.755 107.066 651.996 199.415 602.273C266.73 566.038 275.396 506.077 313.379 445.413C332.894 413.488 359.402 384.171 391.211 359.333C494.291 279.048 586.777 295.756 725.636 261.571C760.839 253.008 795.641 241.849 829.613 228.23C1004.63 157.988 1201.81 12.7686 1184.71 -113.461",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.803 426.082C-70.4395 623.266 108.224 631.915 203.175 584.498C271.682 550.321 283.08 492.142 322.17 433.496C342.628 402.047 369.281 373.093 400.733 348.151C502.002 268.136 591.597 278.932 730.549 243.251C765.559 234.352 800.203 223.267 834.176 210.094C1010.74 141.362 1210.21 8.03581 1198.67 -115.222",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-427.829 406.93C-70.3576 600.787 110.407 613.888 206.946 566.743C275.882 533.152 290.832 478.356 330.898 421.581C352.299 390.647 379.096 362.058 410.172 337.005C509.632 257.259 596.279 262.168 735.122 225.058C769.987 215.868 804.531 204.858 838.538 192.099C1016.69 124.964 1218.41 3.46575 1212.4 -116.83",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-422.606 387.666C-70.2584 578.275 110.473 591.598 210.736 549.109C281.427 518.827 298.582 464.415 339.642 409.631C361.957 379.234 388.899 350.999 419.601 325.837C517.251 246.36 601.044 245.366 739.804 206.814C774.517 197.306 808.957 186.357 842.991 174.011C1022.69 108.387 1226.73 -1.13271 1226.22 -118.508",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-417.522 368.465C-70.232 555.822 111.624 571.571 214.449 531.225C286.315 503.113 306.475 450.644 348.407 397.726C371.618 367.892 398.723 340.012 429.07 314.757C524.872 235.54 605.792 228.6 744.526 188.658C776.795 179.337 811.036 168.922 847.493 156.031C1028.79 91.9702 1235.02 -5.79538 1240.07 -120.144",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-412.438 349.263C-70.0773 533.285 112.667 551.307 218.211 513.526C291.193 487.377 314.385 436.84 357.236 385.817C381.349 356.555 408.623 328.995 438.602 303.596C532.593 224.648 610.614 211.851 749.302 170.4C781.593 160.758 815.731 150.337 852.076 137.937C1034.72 75.5296 1243.32 -10.4362 1253.92 -121.779",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-407.315 330.072C-69.9672 510.795 113.731 531.086 221.953 495.707C296.013 471.512 322.415 422.93 365.899 373.906C390.876 345.243 418.311 317.997 447.912 292.457C540.121 213.766 615.25 195.057 753.932 152.26C786.106 142.359 820.272 131.925 856.495 119.995C1040.94 59.1622 1251.68 -14.9474 1267.81 -123.327",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-402.232 310.87C-69.8861 488.318 114.774 510.822 225.64 477.99C300.769 455.727 330.289 409.194 374.588 361.982C400.438 333.953 428.061 307.018 457.295 281.337C547.666 202.927 619.913 178.328 758.52 133.956C790.697 123.69 824.789 113.316 860.854 101.847C1046.91 42.6751 1259.85 -19.6588 1281.57 -125.079",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397.148 291.669C-69.7869 465.806 115.873 490.533 229.465 460.211C305.681 439.846 338.367 395.391 383.37 350.042C409.245 323.983 435.818 297.48 466.789 270.166C555.36 192.048 624.706 161.515 763.268 115.71C795.402 105.126 829.448 94.7981 865.437 83.7526C1053.11 26.2425 1268.27 -24.3282 1295.5 -126.774",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-392.062 272.468C-69.7154 443.229 116.76 470.288 233.199 442.447C310.511 424.002 346.465 381.632 392.126 338.115C419.068 312.432 445.88 286.236 476.23 259.021C562.961 181.107 629.427 144.76 767.962 97.4888C800.043 86.5658 834.071 76.2717 869.855 65.7335C1059.13 9.94056 1276.53 -28.9225 1309.28 -128.405",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-387.034 253.291C-69.605 420.816 117.94 449.884 236.932 424.684C315.311 408.093 354.572 367.895 400.871 326.166C428.928 300.889 455.941 274.993 485.548 247.904C570.526 170.311 634.016 128.013 772.635 79.2245C804.71 67.9927 838.665 57.7576 874.308 47.646C1065.24 -6.39904 1284.84 -33.5421 1323.12 -130.062",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-381.857 234.074C-69.496 398.326 118.908 429.525 240.702 406.929C320.186 392.203 362.736 354.209 409.607 314.273C438.789 289.424 466.039 263.758 495.107 236.73C578.22 159.431 638.883 111.217 777.337 61.0249C810.836 49.1863 844.717 38.7228 878.846 29.6755C1071.32 -22.7046 1293.22 -38.242 1336.97 -131.698",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-376.771 214.873C-69.395 375.815 120.127 409.131 244.363 389.225C324.942 376.342 370.828 340.584 418.391 302.334C448.708 277.935 476.139 252.525 504.548 225.586C585.878 148.543 643.622 94.4299 781.975 42.8296C815.3 30.6769 849.124 20.2429 883.236 11.5923C1077.47 -38.8797 1301.45 -42.8233 1350.87 -133.28",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-371.687 195.671C-69.314 353.336 121.277 388.585 248.216 371.433C329.815 360.374 379.104 326.925 427.127 290.44C458.588 266.513 486.172 241.293 513.959 214.452C593.451 137.691 648.341 77.6749 786.723 24.5831C819.884 12.1451 853.665 1.76063 887.763 -6.47744C1083.52 -55.1949 1309.75 -47.465 1364.67 -135.023",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-366.576 176.457C-69.254 330.738 122.234 368.203 251.949 353.669C334.725 344.415 387.316 313.348 435.853 278.525C468.589 255.062 496.242 230.071 523.398 203.307C601.099 126.858 653.05 60.899 791.405 6.34046C824.405 -6.36768 858.147 -16.7038 892.225 -24.5433C1089.61 -71.4232 1318.06 -52.0843 1378.51 -136.68",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-361.491 157.256C-69.2437 308.396 123.339 347.704 255.681 335.828C339.561 328.361 395.472 299.718 444.551 266.468C478.338 243.492 506.301 218.673 532.779 192.031C608.651 115.809 657.73 43.9807 796.06 -11.9673C828.896 -24.9454 862.605 -35.2347 896.66 -42.6742C1095.67 -87.695 1326.44 -56.9175 1392.31 -138.424",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-356.408 138.054C-69.0342 285.834 124.47 327.193 259.452 318.151C344.5 312.468 403.724 286.305 453.363 254.671C488.372 232.339 516.392 207.572 542.256 180.973C616.29 105.032 662.488 27.313 800.771 -30.1449C833.44 -43.4038 867.123 -53.6483 901.151 -60.6749C1101.8 -103.759 1334.67 -61.3448 1406.19 -139.994",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351.285 118.863C-68.9245 263.345 125.554 306.574 263.112 300.447C349.281 296.517 411.81 272.889 461.979 242.806C498.2 221.097 526.352 196.401 551.587 169.955C623.828 94.2493 667.134 10.6184 805.373 -48.2722C837.888 -61.7917 871.556 -71.996 905.56 -78.6379C1107.79 -119.551 1342.86 -65.9353 1419.98 -141.603",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-346.231 99.6745C103.9 328.841 338.652 305.317 470.843 230.83C615.149 149.52 623.649 14.9169 810.165 -66.5641C1028.97 -162.125 1337.28 -58.2868 1433.88 -143.284",
    stroke: "#E7EBFA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#CFD8F5",
    stroke: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0831 20L21.2498 15M21.2498 15L17.0831 10M21.2498 15L8.74976 15",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 7376,
    fill: "white",
    transform: "translate(-167 -282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1041,
    fill: "white",
    transform: "translate(-167 -282)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreArrowHero);
export default __webpack_public_path__ + "static/media/explore-arrow-hero.cf28f5897311ba1a2c8fe0a5a9258abd.svg";
export { ForwardRef as ReactComponent };